import React from "react";

/**
 * The NUMA mark.
 *
 * Deliberately deterministic: the mascot used to be picked at random on every
 * render, so the brand changed shape as you navigated. A mark you cannot
 * recognise is not a mark. Pass `variant` to choose a pose on purpose.
 */
export const NUMA_POSES = Array.from({ length: 11 }, (_, i) => `/data/numa${i + 1}.png`);

export default function NumaLogo({ size = 9, className = "", variant = 0, alt = "" }) {
  const px = size * 4;
  const src = NUMA_POSES[Math.abs(variant) % NUMA_POSES.length];
  return (
    <img
      src={src}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      width={px}
      height={px}
      className={`object-contain select-none ${className}`}
      style={{ width: px, height: px, minWidth: px }}
      draggable={false}
      onError={(e) => {
        e.currentTarget.style.visibility = "hidden";
      }}
    />
  );
}
